import { render, staticRenderFns } from "./EmployesList.vue?vue&type=template&id=629a9d2b&scoped=true&"
import script from "./EmployesList.vue?vue&type=script&lang=js&"
export * from "./EmployesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629a9d2b",
  null
  
)

export default component.exports